import HunnyTooltip from 'UIKit/Tooltip/Tooltip'
import { useUserBonus } from 'state/bonus/hooks/useUserBonus'
import theme from 'theme'
import BonusCenterTooltipContent from './bonusCenterTooltipContent'

const BonusHoverTooltip = () => {
  const { bonuses } = useUserBonus()

  return (
    !!bonuses?.length && (
      <HunnyTooltip
        id="bonus-menu"
        place="right"
        className="custom-tip"
        classNameArrow="custom-arrow-tip"
        offset={10}
        style={{
          padding: '20px',
          background: theme.colors.cardBackground,
          borderRadius: theme.radii.small,
          border: `1px solid ${theme.colors.modalHeaderBackground}`,
        }}
        clickable
      >
        <BonusCenterTooltipContent bonuses={bonuses} />
      </HunnyTooltip>
    )
  )
}

export default BonusHoverTooltip
